import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer-mobile',
  styleUrls: ['./footer.component.scss'],
  template: `
  <nb-actions size="small" fullWidth>
    <nb-action icon="home-outline" title="Home" routerLink="/app/dashboard" routerLinkActive="active"></nb-action>
    <nb-action icon="calendar-outline" title="Absensi" routerLink="/app/absensi" routerLinkActive="active"></nb-action>
    <nb-action icon="briefcase-outline" title="Kinerja" routerLink="/app/kinerja" routerLinkActive="active"></nb-action>
    <nb-action icon="file-text-outline" title="Laporan" routerLink="/app/laporan" routerLinkActive="active"></nb-action>
    <nb-action icon="person-outline" title="Profil" routerLink="/app/profil" routerLinkActive="active"></nb-action>
  </nb-actions>
  `,
})
export class FooterMobileComponent {
}